import { COLORS } from 'shared/constants/theme';
import themeFactory from '../helpers/themeFactory';

export default themeFactory({
  backgroundColor: COLORS.cerulean,
  borderColor: COLORS.cerulean,
  color: COLORS.white,
  textDecoration: 'none'
});
